import Phaser from "phaser";
import { cButton } from "../cGameObjects/cButton";
import { helper } from "../cGameObjects/helper";
import { Layout } from "../cGameObjects/modules/Layout";
import { cScene } from "../cScene";
import { getStr, getVoice } from "../utils/simpleLocalisation";
import { cGame } from "../cGame";

export class speechBubble extends Phaser.GameObjects.Container {

  static voiceOver: any;

  private layout:Layout = new Layout(this,{} as any)

  private bubbleData: any;
  private lay: Phaser.GameObjects.Container
  private bType: string = '';
  
  private button_x: number = 400;

  constructor(sc:cScene, data:any, cb: Function){
    super(sc,100,100);

    this.bubbleData = data;
    this.layout.setOfs(data.ofs)


    if (!this.bubbleData.stalk){
      this.bubbleData.stalk = 0
    }

    if (this.bubbleData.type === 'wide'){
      this.bType = '_wide'
      this.button_x = 840
    }

    this.lay = new Phaser.GameObjects.Container(sc as any,0,0);
    this.add(this.lay);

    let bTop = new Phaser.GameObjects.Sprite(sc as any,0,0,'bubble',`bubble_top${this.bType}.png`);    
    bTop.setOrigin(0,0)
    this.lay.add(bTop);

    let bMid = new Phaser.GameObjects.Sprite(sc as any,0,28,'bubble',`bubble_mid${this.bType}.png`);    
    bMid.setOrigin(0,0)
    this.lay.add(bMid);

    let bBot = new Phaser.GameObjects.Sprite(sc as any,0,29,'bubble',`bubble_bottom${this.bType}.png`);    
    bBot.setOrigin(0,0)
    this.lay.add(bBot);
    
    let txt = helper.createTextfield(sc, getStr(String(this.bubbleData.value).trim()),`bubble${this.bType}`)
    txt.setOrigin(0,0)
    txt.setPosition(24,20)
    this.lay.add(txt)
    
    bMid.displayHeight = txt.height;
    bBot.y = txt.height + bTop.height

    const triggerEvent = () => {
      if (!this || !this.destroy) return 
      this.destroy(true)
      cb();
    }

    if (this.bubbleData.btn !== false && this.bubbleData.btn !== "true"){
      let btn = new cButton(sc,{name:'',id:'',asset:'btn_bubble',type:'', extra_asset:'icons:arrow_right'})
      btn.events.addListener('click',()=>{
        triggerEvent();
      })
      btn.y = bBot.y+10;
      btn.x = this.button_x + 65;
      this.lay.add(btn);
    }

    bMid.setInteractive({ useHandCursor: true });
    bMid.on('pointerup',()=>{
      triggerEvent();
    });    


    this.lay.alpha = 1;

    var frames = ["bubble_up_1.png","bubble_up_2.png","bubble_up_3.png"];
    let animBubble = new Phaser.GameObjects.Sprite(sc as any,0,-150,'bubble', frames[0]);    
    //animBubble.displayOriginX = 0
    this.add(animBubble);

    this.lay.x = -452/2
    this.lay.y = -bBot.y - 25
    this.lay.setVisible(false);

    // this.add( sc.add.line(0,0,100,0,0,0,0xff0000));
    // this.add( sc.add.line(0,0,0,100,0,0,0xff0000));

    var stalk: Phaser.GameObjects.Sprite
    var stalkOfs: number = Number(this.bubbleData.stalk) / 100;
    
    switch ( this.bubbleData.stalkid ){
      case "to_left":
        stalk = new Phaser.GameObjects.Sprite(sc as any, bBot.width * stalkOfs,28,'bubble','stalk_bottom_1.png');    
        break;
      case "on_leftside":
        stalk = new Phaser.GameObjects.Sprite(sc as any,-268,-bBot.y * stalkOfs,'bubble','stalk_left.png');    
        break;
      case "on_rightside":
        stalk = new Phaser.GameObjects.Sprite(sc as any,bBot.width-185,-bBot.y * stalkOfs,'bubble','stalk_right.png');    
        break;
      default:
        stalk = new Phaser.GameObjects.Sprite(sc as any, bBot.width * stalkOfs,29,'bubble','stalk_bottom_2.png');    
        break;
    }
    stalk.visible = false;
    this.add(stalk);

    var idd = setInterval(()=>{
      animBubble.setFrame( String(frames.shift()) )
      if (frames.length === 0){
        clearInterval(idd);
        this.lay.setVisible(true);
        this.remove(animBubble);
        stalk.visible = true;
      }
    },100);


    if (sc.debugMode){
      this.setupDragging(sc,stalk);
    }

    
    //console.log('SPEAK',cGame.current.state.get('voiceover',null))
    if (cGame.current.state.get('voiceover',null) === 'on'){
      var s = getStr(String(this.bubbleData.value).trim());
      var p = getVoice(String(this.bubbleData.value), this.bubbleData.person as any);
      speechBubble.voiceOver.speak(s, p)
    }
  }

  public close() {
    this.destroy(true)
  }


  setupDragging(sc:any,stalk:any) {
    if (! (window as any).adminLink ) return

    var $this = this
    var $savedPos = [this.lay.x, this.lay.y];


    stalk = new Phaser.GameObjects.Sprite(sc,0,0,'');
    this.add(stalk);

    setTimeout( ()=> {
      stalk.setInteractive({useHandCursor:true});
      sc.input.setDraggable( stalk )
      sc.input.enable(stalk);

      sc.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
        if (gameObj !== stalk) return
        gameObj.x = x;
        gameObj.y = y;
        this.lay.x = $savedPos[0] + gameObj.x;
        this.lay.y = $savedPos[1] + gameObj.y - 29;
      });

      sc.input.on('dragend',(p:any, gameObj:any)=>{
        if (gameObj !== stalk) return
        (window as any).adminLink('updateBubblePosition', {
          id: this.bubbleData._id,
          x : Math.round(gameObj.x + $this.x),
          y : Math.round(gameObj.y-29 + $this.y)
        })
      })

    },500)


  }

}